interface IPaymentCharges {
  chargeAmount: string;
  description: string;
  name: string;
  offerTitle: string;
  paymentMethod: string;
  ruleId: string;
}

export const offerBannerTransformer = (offerBanner: any) => ({
  imageUrl: offerBanner.image_url,
  name: offerBanner.name,
  tncLink: offerBanner.tnc_link,
  aspectRatio: offerBanner.aspect_ratio,
  imageWidth: offerBanner.image_width,
  mwebTncLink: offerBanner.tnc_link,
});

export const offerBannerArrayTransformer = (offerBanners: any) => {
  if (!offerBanners || !offerBanners.length) {
    return [];
  }
  return offerBanners.map((offerBanner: any) => offerBannerTransformer(offerBanner));
};

export const tagsTransformer = (tag: any) => ({
  imageUrl: tag.image_url,
  label: tag.label,
  name: tag.name,
  tncLink: tag.tnc_link,
});

export const tagsArrayTransformer = (tags: any) => {
  if (!tags || !tags.length) {
    return [];
  }
  return tags.map((tag: any) => tagsTransformer(tag));
};

export const extraCartRuleTransformer = (extraCartRule: any) => {
  if (!extraCartRule) {
    return [];
  }
  return {
    offerBanner: offerBannerArrayTransformer(extraCartRule.offer_banner) || [],
    tags: tagsArrayTransformer(extraCartRule.tag) || [],
  };
};

export const paymentRuleTransformer = (rule: PaymentOfferRule) => {
  const config = {
    description: rule.description || "",
    discountAmount: rule.discountAmount || 0,
    discountPercent: rule.discountPercent,
    discountType: rule.discountType,
    finalOrderAmount: rule.finalOrderAmount || 0,
    fixedDiscount: rule.fixedDiscount,
    name: rule.name,
    orderAmount: rule.orderAmount || 0,
    paymentMethod: rule.paymentMethod,
    paymentMethodMessage: rule.paymentMethodMessage,
    ruleId: rule.ruleId,
    ruleKey: rule.ruleKey,
    termsAndConditionsLink: rule.termsAndConditionsLink,
    type: rule.type,
    cashbackAmount: rule.cashbackAmount,
    extraCartRuleParams: extraCartRuleTransformer(rule.extraCartruleParams) || [],
    deltaAmount: rule.deltaAmount,
    maximumDiscount: rule.maximumDiscount,
    minPayableAmount: rule.minPayableAmount,
    offerLongDescription: rule.offerLongDescription,
    offerTNC: rule.offerTNC,
    priority: rule.priority,
    usagePerCustomer: rule.usagePerCustomer,
    validTillDate: rule.validTillDate,
    deltaAmountMsg: rule.deltaAmountMsg,
    offerImageUrl: rule.offerImageUrl,
    discountAmountMsg: rule.discountAmountMsg,
    offerTitle: rule.offerTitle,
    genericDiscountMsg: rule.genericDiscountMsg,
    validityDTO: rule.validityDTO || null,
  };
  return config;
};

export const paymentRulesArrayTransformer = (data: PaymentOfferRule[]) => {
  if (!data || !data.length) {
    return [];
  }
  return data.map((bank: PaymentOfferRule) => paymentRuleTransformer(bank));
};

export const paymentChargesTransformer = (data: IPaymentCharges[]) => {
  if (!data || !data.length) {
    return [];
  }
  return data.map((charges: IPaymentCharges) => ({
    chargeAmount: charges.chargeAmount || 0,
    description: charges.description || "",
    name: charges.name || "",
    offerTitle: charges.offerTitle || "",
    paymentMethod: charges.paymentMethod || "",
    ruleId: charges.ruleId || "",
  }));
};

export const paymentMethodOffersTransformer = (data: PaymentMethodOffer) => {
  if (!data) {
    return {};
  }
  return {
    customerType: data.customerType,
    paymentRules: paymentRulesArrayTransformer(data.paymentRules || []),
    nonEligiblePaymentRules: paymentRulesArrayTransformer(data.nonEligiblePaymentRules || []),
    paymentCharges: paymentChargesTransformer(data.paymentCharges || []),
  };
};
